import { Injectable } from '@angular/core';
import { CoverageQuantitativeAssessmentResultModel } from '../models/calculations';
import { ToolsControlService } from './tools-control.service';

@Injectable({
  providedIn: 'root'
})
export class CoverageQuantitativeAssessmentService {

  active : boolean;
  fullScreenMode : boolean = false;
  results : CoverageQuantitativeAssessmentResultModel[];
  layer: string;

  constructor(private toolsService: ToolsControlService) {}
  closeWindow(){
    this.active = false;
  }
  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
  }
}
